import { FC } from 'react'

import { Badge } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { formatPrettyCurrency } from '../../../../lib/utils'
import { CartEntryItem } from '../CartItem/CartEntryItem/CartEntryItem'
import { BundleUpsells } from '../MiniCart/BundleUpsells/BundleUpsells'
import { BundleGroupObject, MappedBundle } from '../utils'

import { Body, Details, DiscountDisplayText, Items } from './styles'

export const BundleGroup: FC<{
  bundleGroup: BundleGroupObject
  bundlePrograms: Record<string, MappedBundle>
  eventCategory: 'cart' | 'minicart'
}> = ({
  bundleGroup: {
    bundleProgramHandle,
    discountType,
    discountValue,
    minQty,
    lines: entries,
    totalQty,
    qualifiesForDiscount,
  },
  eventCategory,
}) => {
  const {
    cart: { bundle },
  } = useTranslation()
  const { locale, currency } = useLocalization()

  const isOnlyOneItem = entries.length === 1

  const itemsLeftToAdd = minQty - totalQty
  const isPercent = discountType === 'percent'

  const prettyDiscount = !isPercent
    ? formatPrettyCurrency({
        unit: 'dollars',
        value: discountValue,
        currency,
        locale,
      })
    : undefined

  const discountString = isPercent ? String(discountValue) + '%' : String(prettyDiscount)
  const discountDisplayText = qualifiesForDiscount
    ? bundle.discountApplied
    : bundle.addMore
        .replace('{{qty}}', String(itemsLeftToAdd))
        .replace('{{discountValue}}', discountString)

  return (
    <Body>
      <Details>
        <Badge fontWeight='700' size='small'>
          {bundle.bundleAndSave}
        </Badge>
        <DiscountDisplayText $isDiscountApplied={qualifiesForDiscount}>
          {discountDisplayText}
        </DiscountDisplayText>
      </Details>
      <Items $isOnlyOneItem={isOnlyOneItem}>
        {entries.map(entry => (
          <CartEntryItem
            key={entry.item.key}
            entry={entry}
            eventCategory={eventCategory}
            isBundleGroup
          />
        ))}
      </Items>
      {!qualifiesForDiscount ? <BundleUpsells handle={bundleProgramHandle} /> : null}
    </Body>
  )
}
